import type { DefaultDashboardDefinition } from './dashboard-definition';

export const procurementDashboard: DefaultDashboardDefinition = {
  id: "procurement.main",
  appId: "procurement",
  name: "Procurement dashboard",
  record: null,
  queryScope: null,
  placements: [
    {id: 'procurement.top-products.default', widgetId: 'procurement.top-products', placement: {x: 0, y: 8, width: 12, height: 5}},
    {
      id: "procurement.spend-trend.default",
      widgetId: "procurement.spend-trend",
      placement: {
        x: 0,
        y: 0,
        width: 6,
        height: 3,
      },
    },
    {
      id: "procurement.order-trend.default",
      widgetId: "procurement.order-trend",
      placement: {
        x: 6,
        y: 0,
        width: 6,
        height: 3,
      },
    },
    {
      id: "procurement.purchase-count.default",
      widgetId: "procurement.purchase-count",
      placement: {
        x: 0,
        y: 3,
        width: 4,
        height: 1,
      },
    },
    {
      id: "procurement.spend.default",
      widgetId: "procurement.spend",
      placement: {
        x: 4,
        y: 3,
        width: 4,
        height: 1,
      },
    },
    {
      id: "procurement.pending-receipts.default",
      widgetId: "procurement.pending-receipts",
      placement: {
        x: 8,
        y: 3,
        width: 4,
        height: 1,
      },
    },
    {
      id: "procurement.status-list.default",
      widgetId: "procurement.status-list",
      placement: {
        x: 0,
        y: 4,
        width: 6,
        height: 4,
      },
    },
    {
      id: "procurement.vendor-report.default",
      widgetId: "procurement.vendor-report",
      placement: {
        x: 6,
        y: 4,
        width: 6,
        height: 4,
      },
    },
  ],
};
